'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localImages = require('../utils/localImages');

var _localImages2 = _interopRequireDefault(_localImages);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isNewSignupUx = require('../utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

var _Config = require('../selectors/Config');

var _isFunnel = require('../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = function Header() {
  if ((0, _isNewSignupUx2.default)()) {
    // eslint-disable-next-line react/self-closing-comp
    return _react2.default.createElement('span', null);
  }

  var headerClassNames = (0, _classnames2.default)('signup-header signup-header-gdpr', {
    'fb-crm-header': _isFunnel2.default.fbCrm(),
    hidden: (0, _Config.getIsEmbeddedContentFlow)()
  });

  return _react2.default.createElement(
    'div',
    { className: headerClassNames },
    _react2.default.createElement(_UIImage2.default, {
      className: 'header-logo header-logo-gdpr',
      src: _localImages2.default.get('hubspotLogo'),
      responsive: false
    })
  );
};

exports.default = Header;